import React from "react";
import { FormSections, LOVValues, ProgramContainer } from "../../entities/formTemplateDataType";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { MultiSelect } from "primereact/multiselect";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import Utils from "../../utilities/Utils";
import { getElementByFieldName } from "../../utilities/ElementUtils";
import { InputText } from "primereact/inputtext";
import { SummaryStyleList } from "../../entities/Constants";

interface Props {
   // programContainer: ProgramContainer
    formSection: FormSections;
    isEng: boolean;
    dialogVisible:boolean;
    callback;
}

interface State {
    pickedFieldOptions;
}

export class DialogForSectionPropertyComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            pickedFieldOptions: [],
        };
    }

    componentDidMount(): void {
        if(this.props.formSection.FilterField!=null){
            this.onChangeHanlder(this.props.formSection.FilterField)
        }
    }
  

    onChangeHanlder = (newValue) => {
   
        let totalOption = [];
        const programContainer = this.props.formSection.parent;
        const formListPrior = programContainer.ListOfFormSections.filter(p => p.Sequence < this.props.formSection.Sequence);
        formListPrior.forEach(formSection => formSection.ListOfFormSubSections.forEach((subSection) => {
            let pickedField = subSection.ListOfFormSectionElements.filter(ele => ele.LoadBindName == newValue);

            if(pickedField.length>0){
                let options = pickedField[0].ListOfLOVValues?.map(p => ({
                    code: p.code,
                    description: this.props.isEng? p.description:p.FRADescription
                  }));
                totalOption.push(...options);
            }

        }));

        this.setState({ pickedFieldOptions: totalOption });
      //  this.props.callback();
    }

    generateFilter = () => {
        let html = [];
        let elementListWithOptions = [];
        const programContainer = this.props.formSection.parent;
        //get the section list prior to this one
        let formList =programContainer.ListOfFormSections.filter(p=>p.Sequence<this.props.formSection.Sequence && !p.isTechicalErrorPage && !p.NotStep)

        formList.forEach(formSection=> {
            formSection.ListOfFormSubSections.forEach((subSection) => {
                let list = subSection.ListOfFormSectionElements.filter(
                    (q) =>
                        (q.Datatype === "RadioButton" ||
                            q.Datatype === "CheckGroup" ||
                            q.Datatype === "Dropdown")
                ).map((q) => {
                    return {
                        code: q.LoadBindName?.replace(/\s/g, ""),
                        description: this.props.isEng ? q.ENUTitle : q.FRATitle
                    };
                });
                 elementListWithOptions.push(...list);
            });
        });

        if (!this.props.formSection.FilterValue) {
            this.props.formSection.FilterValue = [];
        }

        if (!this.props.formSection.FilterValueFRA) {
            this.props.formSection.FilterValueFRA = [];
        }

        if (!this.props.formSection.FilterField) {
            this.props.formSection.FilterField = [];
        }

        for (let i = 0; i < elementListWithOptions.length; i++) {
            let option = elementListWithOptions[i];
            //from code to find element
            const field = getElementByFieldName(option.code, this.props.formSection);
            const optionList = field?.ListOfLOVValues;

            // if(!Array.isArray(this.props.formSection.FilterValue[i])){
            //     console.log()
            //     this.props.formSection.FilterValue[i]=[]
            // }
            if(!Array.isArray(this.props.formSection.FilterField)){
                this.props.formSection.FilterField=[];
            }
           
            if (Array.from(this.props.formSection.FilterField).indexOf(option["code"]) == -1) {
                this.props.formSection.FilterField.push(option["code"])
            }

            html.push(
                <>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Field</div>
                        <div style={{ width: '60%' }}>{option["description"]}</div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Value</div>
                        <div style={{ width: '60%', }}>
                            <div>
                                {/* @ts-ignore */}
                                <MultiSelect style={{ width: '100%' }}
                                    className="ontario-dropdown-small"
                                    options={optionList}
                                    value={this.props.isEng ? this.props.formSection.FilterValue[i]
                                        :this.props.formSection.FilterValueFRA[i]}
                                    optionLabel={this.props.isEng ? "description" : "FRADescription"}
                                    optionValue="code"
                                    placeholder="Filtering value"
                                    onChange={(e) => {
                                        console.log(e.value);
                                        if (e.value) {
                                            if (this.props.isEng) {
                                                this.props.formSection.FilterValue[i] = e.value;
                                            } else {
                                                this.props.formSection.FilterValueFRA[i] = e.value;
                                            }
                                        }
                              

                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        return html;
    }
    generateContentString = () => {
      
        let htmlString = [];
        htmlString.push(this.generateFilter());

            htmlString.push(
                <div style={{ width: "100%", paddingTop: "5px" }}>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSection.PreScript + this.props.formSection.Id}>Pre Script</label>
                        </div>
                        <div style={{ width: '60%' }}>   <InputTextarea className="ontario-input"
                            value={this.props.formSection.PreScript} id={"tbl_" + this.props.formSection.PreScript + this.props.formSection.Id}
                            onChange={(e) => { this.props.formSection.PreScript = e.target.value; this.props.callback() }} />
                        </div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSection.PostScript + this.props.formSection.Id}>Post Script</label>
                        </div>
                        <div style={{ width: '60%' }}>   <InputTextarea className="ontario-input"
                            value={this.props.formSection.PostScript} id={"tbl_" + this.props.formSection.PostScript + this.props.formSection.Id}
                            onChange={(e) => { this.props.formSection.PostScript = e.target.value; this.props.callback() }} />
                        </div>
                    </div>

                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSection.IsFrontPage}>Is Front Page</label>
                        </div>
                        <div>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.formSection.IsFrontPage}
                                onChange={(e) => { this.props.formSection.IsFrontPage = e.checked; this.props.callback() }}
                                checked={this.props.formSection.IsFrontPage} />
                        </div>
                    </div>

                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSection.IsTerminationPage}>Is Termination Page</label>
                        </div>
                        <div>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.formSection.IsTerminationPage}
                                onChange={(e) => { this.props.formSection.IsTerminationPage = e.checked; this.props.callback() }}
                                checked={this.props.formSection.IsTerminationPage} />
                        </div>
                    </div>

                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSection.NextButtonLabel}>Next button label</label>
                        </div>

                        <div style={{ width: '60%' }}>   
                            <InputText className="ontario-input"
                            value={this.props.isEng?this.props.formSection.NextButtonLabel:this.props.formSection.NextButtonLabelFRA} 
                            id={"tbl_" + this.props.formSection.NextButtonLabel + this.props.formSection.Id}
                            onChange={(e) => {
                                if (this.props.isEng)
                                    this.props.formSection.NextButtonLabel = e.target.value;
                                else
                                    this.props.formSection.NextButtonLabelFRA = e.target.value;

                                this.props.callback();
                            }} />
                        </div>

                    </div>

                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSection.NextButtonLabel}>Back button label</label>
                        </div>

                        <div style={{ width: '60%' }}>   
                            <InputText className="ontario-input"
                            value={this.props.isEng?this.props.formSection.BackButtonLabel:this.props.formSection.BackButtonLabelFRA} 
                            id={"tbl_" + this.props.formSection.BackButtonLabel + this.props.formSection.Id}
                            onChange={(e) => {
                                if (this.props.isEng)
                                    this.props.formSection.BackButtonLabel = e.target.value;
                                else
                                    this.props.formSection.BackButtonLabelFRA = e.target.value;

                                this.props.callback();
                            }} />
                        </div>

                    </div>
                  
                    <div style={{ display: this.props.formSection.BackButtonLabel?"flex":'none', marginTop: '10px' }} >
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSection.BackButtonURL}>Back button URL</label>
                        </div>

                        <div style={{ width: '60%' }}>   
                            <InputText className="ontario-input"
                            value={this.props.isEng?this.props.formSection.BackButtonURL:this.props.formSection.BackButtonURLFRA} 
                            id={"tbl_" + this.props.formSection.BackButtonURL + this.props.formSection.Id}
                            onChange={(e) => {
                                if (this.props.isEng)
                                    this.props.formSection.BackButtonURL = e.target.value;
                                else
                                    this.props.formSection.BackButtonURLFRA = e.target.value;

                                this.props.callback();
                            }} />
                        </div>

                    </div>

                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSection.GetToken}>Get Token</label>
                        </div>

                        <div style={{ width: '60%' }}>
                        <Checkbox checked={this.props.formSection.GetToken == 'Y'} value={this.props.formSection.GetToken}
                                    className='p-checkbox' title="For Siebel"
                                    onChange={(e) => {
                                        this.props.formSection.GetToken = e.checked ? 'Y' : 'N';
                                        this.props.callback();
                                    }} />
                        </div>
                    </div>
                    {this.props.formSection.CustomizedReviewPage && (
                        <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"summary-style-" + this.props.formSection.Id}>Customized Review Style</label>
                        </div>

                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <Dropdown
                                className="ontario-dropdown"
                                options={SummaryStyleList}
                                optionLabel='label' 
                                optionValue='val'
                                value={this.props.formSection.CustomizedStyle}
                                onChange={(e) => {
                                    this.props.formSection.CustomizedStyle = e.value    ;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                    )}
                </div>
            );

        return htmlString;
    };
  
    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    generateHtmlString = () => {
        let html = [];
        html.push(<>
        {/* @ts-ignore */}
        <Dialog header={this.props.isEng ? "Section properties for " + this.props.formSection.ENUTitle : "Section properties for" + this.props.formSection.FRATitle} footer={this.renderFooter()}
            visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
            {this.generateContentString()}
        </Dialog></>);
        return html;
    }

  
    render() {
    
        return (
            <div>
                {this.generateHtmlString()}
            </div>
        );
    }
}
